/**
 * Helper function to check if URL is an image
 */
export const isImageUrl = (url: string): boolean => {
  const imageExtensions = /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i;
  const imageTypes = /^data:image\/|image\/jpeg|image\/png|image\/gif|image\/webp|image\/bmp|image\/svg/i;
  return imageExtensions.test(url) || imageTypes.test(url);
};

/**
 * Helper function to check if URL is a video
 */
export const isVideoUrl = (url: string): boolean => {
  const videoExtensions = /\.(mp4|webm|ogg|mov|avi|mkv)$/i;
  const videoTypes = /^data:video\/|video\/mp4|video\/webm|video\/ogg|video\/quicktime|video\/x-msvideo|video\/x-matroska/i;
  return videoExtensions.test(url) || videoTypes.test(url);
};
